"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The EventBusHelper is used to keep track of Kurtosys App Template events on an embedded page.
 *
 * This class is to be implemented within the ksys-app-start & ksys-app-manager and will be use the HTML event system to communicate with other app templates on the page.
 *
 * NOTE: unit tests are not possible within the ksys-app-template for this helper as this class relies on the HTML DOM, which is not available within Jest by default.
 *
 * @export
 * @class EventBusHelper
 */
var EventBusHelper = /** @class */ (function () {
    function EventBusHelper(applicationEventBusID) {
        this.applicationEventBusID = applicationEventBusID;
        // look for our custom web component, otherwise add it to the page if it doesn't exist.
        var eventBus = document.querySelector('ksys-event-bus');
        if (!eventBus) {
            try {
                eventBus = document.createElement('ksys-event-bus');
            }
            catch (e) {
                // inform the console that an issue occurred here and let the app templates handle the error details.
                console.error('Error creating web component "ksys-event-bus"');
                throw e;
            }
            document.body.appendChild(eventBus);
        }
        this.bus = eventBus;
    }
    /**
     * Register using Element.addEventListener on the custom web component which is available on the page for the event bus
     *
     * @param eventType string
     * @param listener EventListenerOrEventListenerObject
     * @param [options] AddEventListenerOptions
     */
    EventBusHelper.prototype.register = function (eventType, listener, options) {
        this.bus.addEventListener(eventType, listener, options);
    };
    /**
     * Unregister using Element.removeEventListener on the custom web component which is available on the page for the event bus
     *
     * @param eventType
     * @param listener
     * @param [options]
     */
    EventBusHelper.prototype.unregister = function (eventType, listener, options) {
        this.bus.removeEventListener(eventType, listener, options);
    };
    /**
     * Trigger an event which will be consumed by all apps registered to event type linked to the event bus.
     *
     * @template T
     * @param eventType
     * @param [customEventInit]
     */
    EventBusHelper.prototype.trigger = function (eventType, customEventInit) {
        var _a;
        try {
            // Checks if the eventDetails exist in the sessionStorage, and sets it to the existing value else defaults it to a new {}
            var eventDetails = (sessionStorage.getItem('eventDetails') !== null) ? JSON.parse(sessionStorage.getItem('eventDetails')) : {};
            eventDetails[this.applicationEventBusID] = __assign(__assign({}, eventDetails[this.applicationEventBusID]), (_a = {}, _a[eventType] = customEventInit, _a));
            sessionStorage.setItem('eventDetails', JSON.stringify(eventDetails));
        }
        catch (e) {
            console.warn('Failed to parse event bus storage', e.stack);
        }
        this.bus.dispatchEvent(new CustomEvent(eventType, customEventInit));
    };
    return EventBusHelper;
}());
exports.EventBusHelper = EventBusHelper;
//# sourceMappingURL=EventBusHelper.js.map